import i18n from "@/setup/i18n"; // Import the i18n instance directly
import "@socotec.io/socio-aos-component/style.css";
import { socioVuetifyConfig } from "@socotec.io/socio-vue-components";
import "@socotec.io/socio-vue-components/style.css";
import merge from "lodash/merge";
import { useI18n } from "vue-i18n";
import { createVuetify } from "vuetify";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import "vuetify/styles";

export default createVuetify(
  merge({}, socioVuetifyConfig, {
    theme: {
      themes: {
        light: {
          colors: {
            primary: "#00669e",
            secondary: "#0082DE",
            accent: "#fcb902",
            error: "#FF5252",
            third: "#00ace8",
            bimaction: "#30374b",
            "header-primary": "#28669a",
            "light-blue": "#00ace8",
            "body-color": "#94979a",
            black: "#333333",
          },
          variables: {
            "theme-on-secondary": "#FFFFFF",
            "input-padding-top": "12px",
          },
        },
      },
    },
    defaults: {
      VContainer: {
        class: "pa-0",
      },
      VSelect: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VTextField: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
        variant: "underlined",
      },
      VCheckbox: {
        density: "compact",
        color: "primary",
      },
      VAutocomplete: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VCardTitle: {
        style: "display:flex",
      },
      VLayout: {
        style: "z-index: 0",
      },
      VRadioGroup: {
        color: "primary",
      },
      VTextarea: {
        variant: "underlined",
      },
    },
    VTextField: {
      density: "compact",
      color: "primary",
      clearIcon: "mdi-close",
      variant: "outlined",
      locale: {
        adapter: createVueI18nAdapter({ i18n, useI18n }),
      },
      VCheckbox: {
        density: "compact",
        color: "primary",
      },
      VAutocomplete: {
        density: "compact",
        color: "primary",
        clearIcon: "mdi-close",
      },
      VCardTitle: {
        style: "display:flex",
      },
      VLayout: {
        style: "z-index: 0",
      },
      VRadioGroup: {
        color: "primary",
      },
      VTextarea: {
        variant: "outlined",
      },
    },
    locale: {
      adapter: createVueI18nAdapter({ i18n, useI18n }),
    },
  }),
);
